import { useQuery } from '@tanstack/react-query';
import { getGivingOptions } from '@/lib/api/donations';
import { useRegionDetection } from './useRegionDetection';

/**
 * Hook to fetch available giving options
 * Omit region to let backend detect from IP (more reliable for VPN seekers)
 */
export function useGivingOptions() {
  const { locale, timezone } = useRegionDetection();

  return useQuery({
    queryKey: ['giving-options', locale, timezone],
    queryFn: () =>
      getGivingOptions({
        // We omit 'region' so backend can perform IP-based detection
        // locale,
        // timezone,
      }),
    staleTime: 10 * 60 * 1000, // Cache for 10 minutes
  });
}
